import { render } from "./TgBotSettingsBlock.vue?vue&type=template&id=0c47d5e0"
import script from "./TgBotSettingsBlock.vue?vue&type=script&lang=js"
export * from "./TgBotSettingsBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__